/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateMap } from '../models/CreateMap';
import type { CreateMapgroup } from '../models/CreateMapgroup';
import type { Map } from '../models/Map';
import type { MapCollection } from '../models/MapCollection';
import type { Mapgroup } from '../models/Mapgroup';
import type { MapgroupsCollection } from '../models/MapgroupsCollection';
import type { MapgroupWithMaps } from '../models/MapgroupWithMaps';
import type { UpdateMap } from '../models/UpdateMap';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MeteoMapsService {
    /**
     * Fetch all Mapgroups
     * @returns MapgroupsCollection ok
     * @throws ApiError
     */
    public static getMapgroups(): CancelablePromise<MapgroupsCollection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mapgroups',
        });
    }
    /**
     * Add a new Mapgroup
     * @returns Mapgroup created
     * @throws ApiError
     */
    public static createMapgroup({
        requestBody,
    }: {
        requestBody: CreateMapgroup,
    }): CancelablePromise<Mapgroup> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mapgroups',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `invalid mapgroup body`,
            },
        });
    }
    /**
     * Get a Mapgroup
     * @returns MapgroupWithMaps ok
     * @throws ApiError
     */
    public static getMapgroup({
        mapgroupUrn,
    }: {
        /**
         * URN of Mapgroup
         */
        mapgroupUrn: string,
    }): CancelablePromise<MapgroupWithMaps> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mapgroups/{mapgroupUrn}',
            path: {
                'mapgroupUrn': mapgroupUrn,
            },
            errors: {
                404: `not found`,
            },
        });
    }
    /**
     * Update only certain attributes of a Mapgroup
     * @returns Mapgroup updated
     * @throws ApiError
     */
    public static updateMapgroup({
        mapgroupUrn,
        requestBody,
    }: {
        /**
         * URN of Mapgroup
         */
        mapgroupUrn: string,
        requestBody: UpdateMap,
    }): CancelablePromise<Mapgroup> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/mapgroups/{mapgroupUrn}',
            path: {
                'mapgroupUrn': mapgroupUrn,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `invalid patch mapgroup body`,
                404: `not found`,
            },
        });
    }
    /**
     * Replace a Mapgroup
     * @returns Mapgroup updated
     * @throws ApiError
     */
    public static replaceMapgroup({
        mapgroupUrn,
        requestBody,
    }: {
        /**
         * URN of Mapgroup
         */
        mapgroupUrn: string,
        requestBody: CreateMapgroup,
    }): CancelablePromise<Mapgroup> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/mapgroups/{mapgroupUrn}',
            path: {
                'mapgroupUrn': mapgroupUrn,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `invalid mapgroup body`,
                404: `not found`,
            },
        });
    }
    /**
     * Delete a Mapgroup
     * @returns void
     * @throws ApiError
     */
    public static deleteMapgroup({
        mapgroupUrn,
    }: {
        /**
         * URN of Mapgroup
         */
        mapgroupUrn: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/mapgroups/{mapgroupUrn}',
            path: {
                'mapgroupUrn': mapgroupUrn,
            },
            errors: {
                404: `not found`,
            },
        });
    }
    /**
     * Get all Maps of a Mapgroup
     * @returns MapCollection ok
     * @throws ApiError
     */
    public static getMapgroupMaps({
        mapgroupUrn,
    }: {
        /**
         * URN of Mapgroup
         */
        mapgroupUrn: string,
    }): CancelablePromise<MapCollection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mapgroups/{mapgroupUrn}/maps',
            path: {
                'mapgroupUrn': mapgroupUrn,
            },
            errors: {
                404: `not found`,
            },
        });
    }
    /**
     * Create a new Map in the Mapgroup
     * @returns Map created
     * @throws ApiError
     */
    public static createMap({
        mapgroupUrn,
        requestBody,
    }: {
        /**
         * URN of Mapgroup
         */
        mapgroupUrn: string,
        requestBody: CreateMap,
    }): CancelablePromise<Map> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mapgroups/{mapgroupUrn}/maps',
            path: {
                'mapgroupUrn': mapgroupUrn,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get a Map
     * @returns Map ok
     * @throws ApiError
     */
    public static getMap({
        mapgroupUrn,
        mapUrn,
    }: {
        /**
         * URN of Mapgroup
         */
        mapgroupUrn: string,
        /**
         * URN of Map
         */
        mapUrn: string,
    }): CancelablePromise<Map> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mapgroups/{mapgroupUrn}/maps/{mapUrn}',
            path: {
                'mapgroupUrn': mapgroupUrn,
                'mapUrn': mapUrn,
            },
            errors: {
                404: `not found`,
            },
        });
    }
    /**
     * Update only certain attributes of a Map
     * @returns Map ok
     * @throws ApiError
     */
    public static updateMap({
        mapgroupUrn,
        mapUrn,
        requestBody,
    }: {
        /**
         * URN of Mapgroup
         */
        mapgroupUrn: string,
        /**
         * URN of Map
         */
        mapUrn: string,
        requestBody: UpdateMap,
    }): CancelablePromise<Map> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/mapgroups/{mapgroupUrn}/maps/{mapUrn}',
            path: {
                'mapgroupUrn': mapgroupUrn,
                'mapUrn': mapUrn,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `not found`,
            },
        });
    }
    /**
     * Replace a Map
     * @returns Map ok
     * @throws ApiError
     */
    public static replaceMap({
        mapgroupUrn,
        mapUrn,
        requestBody,
    }: {
        /**
         * URN of Mapgroup
         */
        mapgroupUrn: string,
        /**
         * URN of Map
         */
        mapUrn: string,
        requestBody: CreateMap,
    }): CancelablePromise<Map> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/mapgroups/{mapgroupUrn}/maps/{mapUrn}',
            path: {
                'mapgroupUrn': mapgroupUrn,
                'mapUrn': mapUrn,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `not found`,
            },
        });
    }
    /**
     * Delete a Map
     * @returns void
     * @throws ApiError
     */
    public static deleteMap({
        mapgroupUrn,
        mapUrn,
    }: {
        /**
         * URN of Mapgroup
         */
        mapgroupUrn: string,
        /**
         * URN of Map
         */
        mapUrn: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/mapgroups/{mapgroupUrn}/maps/{mapUrn}',
            path: {
                'mapgroupUrn': mapgroupUrn,
                'mapUrn': mapUrn,
            },
            errors: {
                404: `not found`,
            },
        });
    }
}
